'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _decisivUiUtils = require('decisiv-ui-utils');

var _decisivIconixReact = require('decisiv-iconix-react');

var _decisivIconixReact2 = _interopRequireDefault(_decisivIconixReact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ICONS = {
  danger: 'exclamation-triangle',
  info: 'info-circle',
  success: 'check',
  warning: 'exclamation-circle'
};

var styles = function styles() {
  return '\n  margin-right: ' + (0, _decisivUiUtils.px2rem)(5) + ';\n';
};

var propTypes = {
  type: _propTypes2.default.oneOf(['danger', 'info', 'success', 'warning']).isRequired
};

var Icon = (0, _decisivUiUtils.buildStyledComponent)('Icon', (0, _styledComponents2.default)(_decisivIconixReact2.default).attrs({
  name: function name(_ref) {
    var type = _ref.type;
    return ICONS[type];
  },
  modifiers: function modifiers(_ref2) {
    var type = _ref2.type;
    return [type];
  }
}), styles, { propTypes: propTypes });

exports.default = Icon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/MessageSmall/Icon.js
// module id = 1681
// module chunks = 2